import ImportCoveredChecklistFieldsArray from './ImportCoveredChecklistFieldsArray';

// The Security Checklist fields the Import from Schedule D/E review captions "Not found in Schedule D/E" when the
// submission gave them no value: the contract import's fields plus the four information classifications, which the
// form asks for. The fields the form never asks for (the notification periods, data transfer and retention, the
// retention periods, logo and name usage) are therefore always captioned, so the reviewer knows the value shown is
// the one the checklist already had. Mirror of the backend ScheduleEdChecklistImportResource.
const ScheduleEdImportCoveredChecklistFieldsArray = [
  ...ImportCoveredChecklistFieldsArray,
  'PublicInformationClassification',
  'InternalInformationClassification',
  'RestrictedInformationClassification',
  'ConfidentialInformationClassification',
];

export default ScheduleEdImportCoveredChecklistFieldsArray;
